import { Typography, Box, Paper } from '@mui/material';


const ButtonsOptions = props => {

    return (
        <Paper variant="outlined" sx={{ width: '100%', mb: 1 }}>
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    ml: 2,
                    mr: 2,
                    mb: 0
                }}
                >
                <Typography
                    sx={{ m: 2 }}
                    variant="h5"
                    >
                    Emails
                </Typography>
                
            </Box>
        </Paper>
    )
};

export default ButtonsOptions;